<template>
	<div class="page" style="width: 100% !important;">
		<!--  首页  -->
		<div class="app-container">

			<div class="content-wapper" style="text-align: center">
				<div class="contents" style="display:inline-block;" align="center">
					<div class="content-left">
						<el-tabs type="border-card" :stretch="true">
							<el-tab-pane>
								<span slot="label">
									<img src="../../assets/images/main/new/zscq.png" style="vertical-align:middle;" />
									知识产权
								</span>
								<div>
									<el-row :gutter="20">
										<el-col :span="8">
											<div class="grid-contents" @click="openNewPage('/main/zscqzhfw/zscqzyzh')">
												<img src="../../assets/images/main/new/zscq/zscqdt.png" style="" />
											</div>
										</el-col>
										<el-col :span="8">
											<div class="grid-contents" @click="openNewPage('/main/zscqzhfw/zyrzfw')">
												<img src="../../assets/images/main/new/zscq/zyrz.png" style="" />
											</div>
										</el-col>
										<el-col :span="8">
											<div class="grid-contents" @click="openNewPage('/main/zscqzhfw/fwlmjj')">
												<img src="../../assets/images/main/new/zscq/zscqlm.png" style="" />
											</div>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="8">
											<div class="grid-contents" @click="openNewPage('/main/zltszhfw/pxfw')">
												<img src="../../assets/images/main/new/zscq/wzjt.png" style="" />
											</div>
										</el-col>
										<el-col :span="8">
											<div class="grid-contents"
												@click="openNewPage('https://cnipa.chinakenet.com/')">
												<img src="../../assets/images/main/new/zscq/gykt.png" style="" />
											</div>
										</el-col>
										<el-col :span="8">
											<div class="grid-contents"
												@click="openNewPage('/main/zltszhfw/pxfw?code=hwxxfb')">
												<img src="../../assets/images/main/new/zscq/hwxxfb.png" style="" />
											</div>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="8">
											<div class="grid-contents"
												@click="openNewPage('https://pss-system.cponline.cnipa.gov.cn/Disclaimer')">
												<img src="../../assets/images/main/new/zscq/gjzscqggfwwzljsjfxxt.png"
													style="" />
											</div>
										</el-col>
										<el-col :span="8">
											<div class="grid-contents"
												@click="openNewPage('http://kjy.weihai.cn/middleLogin')">
												<img src="../../assets/images/main/new/zscq/kjyzyjsfx.png"
													style="" />
											</div>
										</el-col>
										<el-col :span="8">
											<div class="grid-contents" @click="openNewPage('/main/zscqzhfw/jlhyjtl')">
												<img src="../../assets/images/main/new/zscq/zhcqfwjlhyjtl.png"
													style="" />
											</div>
										</el-col>
									</el-row>
								</div>
							</el-tab-pane>
							<el-tab-pane>
								<span slot="label">
									<img src="../../assets/images/main/new/zlts.png" style="vertical-align:middle;" />
									质量基础设施（NQI）
								</span>
								<div>
									<el-row :gutter="20">
										<el-col :span="8">
											<div class="grid-contents" @click="openSsoPage('os_spjc')">
												<img src="../../assets/images/main/new/zlts/spjc.png" style="" />
											</div>
										</el-col>
										<el-col :span="8">
											<div class="grid-contents" @click="openSsoPage('os_jls')">
												<img src="../../assets/images/main/new/zlts/jljd.png" style="" />
											</div>
										</el-col>
										<el-col :span="8">
											<div class="grid-contents" @click="openNewPage('/main/jyjcfw/tzsbjc')">
												<img src="../../assets/images/main/new/zlts/tzsbjc.png" style="" />
											</div>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="8">
											<div class="grid-contents" @click="openNewPage('/main/jyjcfw/cpzljc')">
												<img src="../../assets/images/main/new/zlts/cpzljc.png" style="" />
											</div>
										</el-col>
										<el-col :span="8">
											<div class="grid-contents" @click="openNewPage('/main/zltszhfw/bzfw')">
												<img src="../../assets/images/main/new/zlts/hgbzxxyfg.png" style="" />
											</div>
										</el-col>
										<el-col :span="8">
											<div class="grid-contents" @click="openNewPage('/main/zltszhfw/bzfw')">
												<img src="../../assets/images/main/new/zlts/bzhjsfw.png" style="" />
											</div>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="8">
											<div class="grid-contents" @click="openNewPage('/main/zltszhfw/rzfw/st')">
												<img src="../../assets/images/main/new/zlts/whsqyfw.png" style="" />
											</div>
										</el-col>
										<el-col :span="8">
											<div class="grid-contents" @click="openNewPage('/main/zltszhfw/rzfw/ts')">
												<img src="../../assets/images/main/new/zlts/tspzrz.png" style="" />
											</div>
										</el-col>
										<el-col :span="8">
											<div class="grid-contents" @click="openNewPage('/main/zltszhfw/zljcss')">
												<img src="../../assets/images/main/new/zlts/zljcss.png" style="" />
											</div>
										</el-col>
									</el-row>
								</div>
							</el-tab-pane>
							<el-tab-pane>
								<span slot="label">
									<img src="../../assets/images/main/new/gsfz.png" style="vertical-align:middle;" />
									小微驿站
								</span>
								<div>
									<el-row :gutter="20">
										<el-col :span="8">
											<div class="grid-contents" @click="openNewPage('/main/xwqyczfw/xwqycx')">
												<img src="../../assets/images/main/new/gsfz/xwqycx.png" style="" />
											</div>
										</el-col>
										<el-col :span="8">
											<div class="grid-contents" @click="openNewPage('/main/xwqyczfw/djyl')">
												<img src="../../assets/images/main/new/gsfz/djyl.png" style="" />
											</div>
										</el-col>
										<el-col :span="8">
											<div class="grid-contents" @click="openNewPage('/main/xwqyczfw/wmcxyl')">
												<img src="../../assets/images/main/new/gsfz/wmcxyl.png" style="" />
											</div>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="8">
											<div class="grid-contents" @click="openNewPage('/main/xwqyczfw/rzfw')">
												<img src="../../assets/images/main/new/gsfz/xwqyrzsq.png" style="" />
											</div>
										</el-col>
										<el-col :span="8">
											<div class="grid-contents"
												@click="openNewPage('/main/xwqyczfw/flwqdxalyfx')">
												<img src="../../assets/images/main/new/gsfz/flwqdxanyfx.png" style="" />
											</div>
										</el-col>
										<el-col :span="8">
											<div class="grid-contents" @click="openNewPage('/main/xwqyczfw/rcdj')">
												<img src="../../assets/images/main/new/gsfz/byssyxx.png" style="" />
											</div>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="8">
											<div class="grid-contents" @click="openNewPage('/main/xwqyczfw/rcdj')">
												<img src="../../assets/images/main/new/gsfz/qyzpxx.png" style="" />
											</div>
										</el-col>
										<el-col :span="8">
											<div class="grid-contents" @click="openNewPage('/main/zscqzhfw/flfgzc')">
												<img src="../../assets/images/main/new/gsfz/hqzc.png" style="" />
											</div>
										</el-col>
										<el-col :span="8">
											<div class="grid-contents" @click="openNewPage('/main/zxzxForm')">
												<img src="../../assets/images/main/new/gsfz/flwqzx.png" style="" />
											</div>
										</el-col>
									</el-row>
								</div>
							</el-tab-pane>
						</el-tabs>
					</div>
					<div class="content-right" v-if="loginUser != null && loginUser.ftype=='1'&&islogin" >
						<p class="welcome">欢迎您</p>
						<div class="avatar">
							<el-avatar :size="50" :src="require('../../assets/images/main/new/user.png')"></el-avatar>
						</div>
						<div class="realname-div">
							<br>
							<span class="realname">个人用户
								<!--{{loginUser.realName}}-->
							</span>
							<br><br>
							<span class="logindate">
								登录时间：{{ parseTime(new Date(), '{y}-{m}-{d} {h}:{i}') }}
							</span>
						</div>
						<div class="qygzs-div">
							<el-button style="background-color: #0279dd;border: 0;color: #FFFFFF;margin-top: 5rem;"
								@click="openEntSudio()">
								个人工作室
							</el-button>
							<br><br><br>
							<el-link @click="logout" target="_blank" :underline="false"
								style="color: #FFFFFF;margin-top: 2rem;">
								退出登录
							</el-link>
						</div>
					</div>
					<div class="content-right" v-else-if="loginUser != null && loginUser.ftype=='2'&&islogin">
						<p class="welcome">欢迎您</p>
						<div class="avatar">
							<el-avatar :size="50" :src="require('../../assets/images/main/new/qy.png')"></el-avatar>
						</div>
						<div class="realname-div">
							<br>
							<span class="realname">{{loginUser.corname}}</span>
							<br><br>
							<span class="logindate">
								登录时间：{{ parseTime(new Date(), '{y}-{m}-{d} {h}:{i}') }}
							</span>
						</div>
						<div class="qygzs-div">
							<el-button style="background-color: #0279dd;border: 0;color: #FFFFFF;margin-top: 5rem;"
								@click="openEntSudio()">
								企业工作室
							</el-button>
							<br>
							<el-link target="_blank" @click="logout" :underline="false"
								style="color: #FFFFFF;margin-top: 2rem;">
								退出登录
							</el-link>
						</div>
					</div>
					<div class="content-right" v-else>
						<div class="qygzs-div">
							<img src="../../assets/images/main/new/qygzs-1.png">
							<br>
							<span @click="openEntSudio()">企业工作室</span>
						</div>
						<div class="introduce">
							<span>
								企业工作室为企业提供政策查询、用工对接、在线咨询、在线申报、培训考试、
								知识产权质押融资、专利转让发布、检验检测、法律维权、小微企业融资、
								党建引领、文明诚信引领、收藏订阅、信息推送等服务功能。
							</span>
						</div>
						<div class="login-div" @click="login">
							<button>
								<img src="../../assets/images/main/new/login-button.png" />
								<span>登录</span>
							</button>
						</div>
					</div>

				</div>
				<div class="content-bottom">
					<span>
						主办单位：威海市市场监督管理局 备案号：鲁ICP备05001812号
					</span>
				</div>
			</div>



		</div>
	</div>
</template>
<script>
	import "@/assets/styles/mainindex/iconfont.css";
	import {getSsoDesInfo,} from "@/api/zlts/jlfw/jljgxx";
	import {getFwjg,} from "@/api/fwjg/fwjg";
	import {
		getlogin,
		getLogout,
		checkUuidValidDate

	} from "@/api/index";
	import { logout as doLogout } from "@/utils/yawei";
	export default {
		//首页
		name: 'MainIndex',
		components: {

		},
		data() {
			return {
				searchParam: {
					type: undefined,
					content: undefined
				},
				time: undefined,
				islogin: false,
				selectplaceholder: '请先选择要查询的业务',
				ywFwjgRecid: undefined,
				loginUser: {},
				/*toUrl:"https://zhjg.weihai.cn/service",*/
				toUrl: undefined,
				ssoOtherOsInfo: {},
			}
		},
		activated() {
			// window.addEventListener("scroll", this.getScroll);
//---------------------
			//--------------
			// console.log("*****************index2输出 ↓↓↓↓*****************");
			let ssessionLogin = JSON.parse(localStorage.getItem('ssessionLoginUser'));
			// console.log("Index2 ssessionLogin==",ssessionLogin);
			if (ssessionLogin != null) {
				this.islogin = ssessionLogin.islogin;
				// console.log("this.islogin", this.islogin);
				this.loginUser = ssessionLogin.user;
				// console.log("this.loginUser", this.loginUser);
				let ywFwjg = ssessionLogin.ywFwjg;
				// console.log("ywFwjg", ywFwjg);
				this.ywFwjgRecid = ssessionLogin.user.ywFwjgRecid;
				//---------------------
				getFwjg(this.ywFwjgRecid).then(response => {
					// debugger
					let ywFwjgObj = response.data;
					let userType = ywFwjgObj.userType;//用户类型
					if(userType ==='1'){
						//个人
						if(ywFwjgObj.llrtel === null || ywFwjgObj.llrtel==='' || ywFwjgObj.llrtel===undefined){
							this.toLink();
						}else if(ywFwjgObj.county === null || ywFwjgObj.county==='' || ywFwjgObj.county===undefined){
							this.toLink();
						}
					}else{
						//企业用户
						if(ywFwjgObj.type === null || ywFwjgObj.type==='' || ywFwjgObj.type===undefined){
							this.toLink();
						}
					}
				});
				//判断一下 是否完善信息


				//--------------
			}
			// console.log("*****************index2输出 ↑↑↑↑*****************");
		},
		deactivated() {
			// window.removeEventListener("scroll", this.getScroll);

		},
		created() {
			this.$emit('appWidthActive', false);
		},
		mounted() {

		},
		methods: {
			toLink(){
				swal({
					title: "温馨提示",
					text: "您的基础信息不全，请前往工作室完善基础信息！",
					icon: "warning",
					buttons: [false,"OK"],
					// dangerMode: true,
					closeOnClickOutside:false,
				}).then((toLink) => {
					if (toLink) {
						this.toOpenPage('/qygzs/index');
					}
				});
			},
			login() {
				localStorage.clear();
				window.location.href = this.Config.sdtyrzfwLoginUrl;
			},
			logout() {
				this.$confirm(
					'是否确认退出?',
					'系统提示', {
						confirmButtonText: '重新登录',
						cancelButtonText: '取消',
						type: 'warning'
					}
				).then(() => {
					doLogout(this.ywFwjgRecid);
				})
			},
			toOpenPage(topath) {
				this.$router.push({
					path: topath
				})
				this.$store.commit('SET_MAININDEX', topath);
			},
			openNewPage(url) {
				// alert(url)
				// this.utils.windowOpen(url);
				sessionStorage.removeItem('indexToRzfwCode');
				if(url == '/main/zltszhfw/rzfw/st'){//三同
					sessionStorage.setItem("indexToRzfwCode",'0501');
					this.utils.windowOpen('/main/zltszhfw/rzfw');
				}else if(url == '/main/zltszhfw/rzfw/ts'){//泰山
					sessionStorage.setItem("indexToRzfwCode",'0401');
					this.utils.windowOpen('/main/zltszhfw/rzfw');
				}
        else{
					this.utils.windowOpen(url);
				}

			},
			openEntSudio(){
        this.utils.windowOpen('/qygzs/index')
      },
      openSsoPage(syscode) {
        //----【】需要修改为recid
        //单点登录跳转
        let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
        if (this.utils.isLoginTimeout()) {
          this.ssoOtherOsInfo.syscode = syscode;
          this.ssoOtherOsInfo.uuid = ssessionLoginUser.ywFwjg.uuid;
          this.ssoOtherOsInfo.usertype = ssessionLoginUser.user.ftype;
          this.ssoOtherOsInfo.loginname = ssessionLoginUser.user.realName;
          this.ssoOtherOsInfo.entname = ssessionLoginUser.user.corname;
          this.ssoOtherOsInfo.entnumber = ssessionLoginUser.user.cornumber;
          this.ssoOtherOsInfo.ywFwjgRecid = ssessionLoginUser.user.ywFwjgRecid;
          // console.log("--------------------------",ssessionLoginUser.user)
          getSsoDesInfo(this.ssoOtherOsInfo).then(response => {
            this.openNewPage(response.url + "?syscode=" + syscode + "&sign=" +
                response.sign);
            return true;
          });
        } else {
          if (ssessionLoginUser != null) {
            let ywFwjgRecid = ssessionLoginUser.user.ywFwjgRecid;
            this.$confirm(
                '登录请求已过期，您可以继续留在该页面，或者重新登录?',
                '系统提示', {
                  confirmButtonText: '重新登录',
                  cancelButtonText: '取消',
                  type: 'warning'
                }
            ).then(() => {
              doLogout(ywFwjgRecid)
            })
          } else {
            localStorage.clear();
            window.location.href = this.Config.sdtyrzfwLoginUrl;
          }
        }
      },
		}
	}
</script>
<style scoped>
	.app-container {
		background-image: url('../../assets/images/main/new/bj-2.png');
		background-repeat: no-repeat;
		background-size: 100% 100%;
		-moz-background-size: 100% 100%;
		height: 100%;
		width: 100% !important;
		position: fixed;

	}

	.content-wapper {
		height: 35.75rem;

	}

	.contents {
		/*padding: 1.5rem 15rem 1rem 15rem;*/
		margin: 30px auto 10px auto;
		text-align: center;
	}

	.contents>.content-left {
		float: left;
		height: 34.75rem;
		width: calc(100vw - 50vw);

	}

	.contents>.content-right {
		position: relative;
		z-index: 99;
		width: calc(100vw - 81vw);
		height: 34.75rem;
		float: left;
		border-radius: 0.625rem 0.625rem 0.625rem 0.625rem;
		margin-left: 0.625rem;
		background-image: url('../../assets/images/main/new/login-bg.png');
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}

	.qygzs-div {
		margin-top: 1.625rem;
		font-size: 20px;
		color: #FFFFFF;
		text-align: center;
	}

	.qygzs-div img {
		width: 3.125rem;
		height: 3.125rem;
	}

	.introduce {
		padding: 1rem;
		text-indent: 2em;
		color: #FFFFFF;
		font-size: 13px;
		font-family: Microsoft YaHei;
		line-height: 25px;
		TEXT-JUSTIFY: inter-ideograph;
		TEXT-ALIGN: justify
	}

	.login-div {
		text-align: center;
	}

	.login-div img {
		vertical-align: middle;
		margin-right: 0.625rem;
	}

	.login-div button {
		background: #007BDF;
		box-shadow: 0px 2px 10px 1px rgba(30, 104, 164, 0.3);
		border-radius: 10px;
		border: 0;
		width: 142px;
		height: 38px;
		color: #FFFFFF;
		line-height: 2.375rem;
	}

	.login-div button:hover {
		cursor: pointer;
	}

	.content-right .welcome {
		color: #FFFFFF;
		font-size: 1.25rem;
		font-weight: 500;
		text-align: center;
	}

	.content-right .avatar {
		text-align: center;
	}

	/deep/ .el-avatar {
		background-color: #FFFFFF;
	}

	.realname-div {
		margin-top: 1rem;
		text-align: center;
	}

	.realname-div .realname {
		color: #FFFFFF;
		font-size: 1.125rem;
		font-weight: 600;
	}

	.realname-div .logindate {
		color: #FFFFFF;
		font-size: 0.625rem;
		margin-top: 1rem;
	}

	.el-row {
		margin-bottom: 7px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.el-col {
		border-radius: 4px;
	}

	.grid-content {
		border-radius: 4px;
		min-height: 119px;
		background: #d3dce6;
	}

	.grid-contents img {
		border-radius: 4px;
		height: 150px;
		width: 280px;
	}

	.grid-contents img:hover {
		cursor: pointer;
	}

	.contents>.content-left::-webkit-scrollbar {
		/*滚动条整体样式*/
		width: 0px;
		/*高宽分别对应横竖滚动条的尺寸 设置为0隐藏滚动条*/
		height: 1px;
	}

	.contents>.content-left::-webkit-scrollbar-thumb {
		/*滚动条里面小方块*/
		border-radius: 5px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #a0d3f3;
	}

	.contents>.content-left::-webkit-scrollbar-track {
		/*滚动条里面轨道*/
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 10px;
		background: #EDEDED;
	}

	.el-tabs--border-card {
		border-radius: 0.625rem;
		background-color: transparent;
		border: 0;


	}

	/deep/ .el-tabs--border-card>.el-tabs__header {
		background-color: #c9e6f8;
		border-radius: 0.625rem 0.625rem 0 0;
		margin-right: -1px;
	}

	/deep/ .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
		background-color: #FFFFFF;
		border-radius: 0.625rem 0.625rem 0 0;
	}


	/deep/ .el-tabs__item {

		height: 3.125rem;
		line-height: 3.125rem;
		font-size: 1rem;
		color: #000000;
		border-radius: 0.625rem 0.625rem 0 0;
		border-right: 2px solid #9dd1f2 !important;
		/* border-left: 2px solid #B3CFE5 !important; */


	}

	/deep/ .el-tabs__item img {
		width: 1.25rem;
		height: 1.25rem;
	}

	/deep/ .el-tabs__content {
		background-color: #FFFFFF;
		border-radius: 0 0 0.625rem 0.625rem;

	}

	/deep/ .el-tabs--border-card>.el-tabs__header .el-tabs__item {
		color: #000000;
	}

	/deep/ .el-tabs--border-card>.el-tabs__content {
		padding: 13px 15px 5px 13px;
	}

	.content-bottom {
		/* position:fixed; */
		z-index: 99999;
		width: calc(100vw);
		/* bottom: 0.625rem; */
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		/* line-height: 32px; */
		text-align: center;
	}
</style>
